import {AbstractVisualFeature} from '#core/application/modules/visual-feature.js';

import {ApplicationHeader} from '../../application-header.js';

import {mainNavigationBarClassicFactory} from './main-navigation-bar-classic.factory.js';

import PALETTE_SCHEMA from './main-navigation-bar-classic.palette-schema.yaml';

class MainNavigationBarClassicFeature extends AbstractVisualFeature {
    get name() {
        return 'MainNavigationBarClassic';
    }

    get paletteSchema() {
        return PALETTE_SCHEMA;
    }

    getSerializableVisualConfig(PALETTE) {
        return mainNavigationBarClassicFactory(PALETTE);
    }
}

new MainNavigationBarClassicFeature(ApplicationHeader);
